module.exports = __webpack_public_path__ + "assets/img/btn-detail-7317c8a1.png";